import React from 'react'
import './style.scss'
//Component imports
import Top from '../../components/top'
import Nav from '../../components/nav'
import HomeCarousel from '../../components/carousel'
import Footer from '../../components/footer'
import Om from '../../components/om'
import Contact from '../../components/contact'
import Gallery from '../../components/gallery'
import {connect} from 'react-redux'
import {
    Row,
    Col
} from 'antd'
const home = (
    <HomeCarousel/>
);

class Home extends React.Component{
    constructor(props){
        super(props);
        this.state = {
            tabkey: "",
            tabToView: "",
        }   
    }
    switchTab = (key) => {
        switch(key){
            case "1":
                this.setState({
                    tabToView: home
                })
                break;
            case "2":
                this.setState({
                    tabToView: <Om/>
                })
                break;
            case "3":
                this.setState({
                    tabToView: <Contact/>
                })
                break;
            case "4":
                this.setState({
                    tabToView: <Gallery/>
                })
                break;
            default:
                break;
        }
    }
    componentDidMount = () => {
        this.switchTab("1")
        this.setState({
            tabToView: home
        })
    }
    render(){
        console.log(this.state)
        return (
            <div className="Home">
                <Top/>
                <Nav tab={(key) => this.switchTab(key)}/> 
                {this.state.tabToView}
                <Footer tab={(key) => this.switchTab(key)}/>
            </div>
        )
    }
}

const mapStateToProps = (store) => ({
    Content: store.content
  })
export default connect(mapStateToProps)(Home);